import { useCallback } from 'react';
import makeHeaders from '../services/headers';
const BASE_API = process.env.REACT_APP_BASE_API_URI;

const _requestHandler = async (call) => {
  try {
    const res = await call() 
    if(res?.Items) return res.Items
    if(res?.items) return res.items
    return res;
  } catch (error) {
    console.error(error)
    // Try to extract error details from response body
    if (error.message === undefined && error.json) {
      try {
        const errorBody = await error.json();
        
        // Check if there's a frontend_error_message in the error response
        if (errorBody?.error && typeof errorBody.error === 'string') {
          try {
            const parsedError = JSON.parse(errorBody.error);
            if (parsedError?.frontend_error_message) {
              return { error, frontend_error_message: parsedError.frontend_error_message };
            }
          } catch (parseError) {
            // If parsing fails, continue with original error handling
          }
        }
      } catch (jsonError) {
        // If json() fails, use original error
      }
    }

    return { error }
  }
}

const _makeRequest = async (method, path, searchParams, body) => {
  let endpoint = `${BASE_API}/${path}`
  try {
  
    const request = {
      method,
      headers: await makeHeaders(),
    }
  
    if (!!body) request.body = JSON.stringify(body)
  
    if (!!searchParams) {
      const query = new URLSearchParams(searchParams)
      endpoint = `${endpoint}?${query.toString()}`
    }
  
    console.debug(`Executing ${method} ${endpoint}`, request)
  
    const response = await fetch(endpoint, request)
    
    if (!response.ok) {
      throw response
    }
  
    const [contentType, contentLength] = ['content-type', 'content-length'].map(header => response.headers.get(header))
  
    var responseJson = null
  
    if (contentType === 'application/json' && Number(contentLength) > 0) {
      responseJson = await response.json()
    }
  
    console.debug(`${method} ${endpoint} Response`, responseJson)
  
    return responseJson

  } catch (error) {
    console.error(`Error while making a request ${method} ${endpoint}`, new Error(error))
    throw error
  }
}

export const useBebackApi = () => {

  const getStoreList = useCallback(
    async (storeId) =>
      await _requestHandler(async () => await _makeRequest('GET', `getStoreList`, {storeId})),
    [],
  )

  const getWorkOrders = useCallback(
    async (storeId, courtesyLyft) =>
      await _requestHandler(async () => await _makeRequest('GET', `getWorkOrders`, {storeId: parseInt(storeId), courtesy_lyft: courtesyLyft})),
    [],
  )

  const isOktaUserFeaturesAdmin = useCallback(
    async (username) =>
      await _requestHandler(async () => await _makeRequest('GET', `validateUser/${username}`)),
    [],
  )

  const getIsStoreValidSC = useCallback(
    async (storeId) =>
      await _requestHandler(async () => await _makeRequest('GET', `isStoreValid/${storeId}`)),
    [],
  )

  const getApptById = useCallback(
    async (appt_id) =>
      await _requestHandler(async () => await _makeRequest('GET', `existingApptById`, {appt_id})),
    [],
  )

  const getNextApptData = useCallback(
    async (store_number, start_date) =>
      await _requestHandler(async () => await _makeRequest('GET', `populateNextApptModal`, {num_days: 1, store_number, start_date})),
    [],
  )

  const updateSites = useCallback(
    async (username, param, body) =>
      await _requestHandler(async () => await _makeRequest('POST', `updateSites/${username}/${param}`, false, body)),
    [],
  )

  const updateWorkOrder = useCallback(
    async (body) =>
      await _requestHandler(async () => await _makeRequest('PUT', `workOrder`, false, body)),
    [],
  )

  const postMarshalSMS = useCallback(
    async (body) =>
      await _requestHandler(async () => await _makeRequest('POST', `postMarshalSMS`, false, body)),
    [],
  )

  const updatePhone = useCallback(
    async (body) =>
      await _requestHandler(async () => await _makeRequest('POST', `updatePhone`, false, body)),
    [],
  )

  const createNextAppt = useCallback(
    async (woNumber, body) =>
      await _requestHandler(async () => await _makeRequest('POST', `newNextAppt/${woNumber}`, false, body)),
    [],
  )

  const searchRide = useCallback(
    async (body) =>
      await _requestHandler(async () => await _makeRequest('POST', `estimateCostRide`, false, body)),
    [],
  )

  const requestRide = useCallback(
    async (body) =>
      await _requestHandler(async () => await _makeRequest('POST', `requestRide`, false, body)),
    [],
  )

  const cancelRide = useCallback(
    async (body) =>
      await _requestHandler(async () => await _makeRequest('POST', `cancelRide`, false, body)),
    [],
  )

  const manageLyftStoreDetails = useCallback(
    async (body) =>
      await _requestHandler(async () => await _makeRequest('POST', `manageLyftStoreDetails`, false, body)),
    [],
  )

  const validateAddress = useCallback(
    async (body) =>
      await _requestHandler(async () => await _makeRequest('POST', `validateAddress`, false, body)),
    [],
  )

  return {
    getStoreList,
    getWorkOrders,
    updateSites,
    postMarshalSMS,
    updatePhone,
    isOktaUserFeaturesAdmin,
    getIsStoreValidSC,
    getApptById,
    getNextApptData,
    createNextAppt,
    updateWorkOrder,
    searchRide,
    requestRide,
    cancelRide,
    manageLyftStoreDetails,
    validateAddress
  }
}